/*
 * @Author: wangbaihe
 * @Date: 2025-07-11 20:14:43
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-08-15 09:31:51
 * @FilePath: \common-mediax\src\apis\MediaCloudJournal\Config.js
 * @Description: MediaCloudJournalConfig
 */

import { createAPI } from '@common'

export default {
  // 获取所有能访问的刊物(可浏览
  getPermJournals: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobmQfsn0kpvsobmt', 'GET', config),
  // 获取所有能访问的刊物(可传入
  getSignJournals: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tjho0kpvsobmt', 'GET', config),
  // 根据刊物Id获取期刊可浏览子栏目(可浏览
  getPermAccessColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobmQfsn0bddftt0dpmvnot', 'GET', config),
  // 根据刊物Id获取期刊可上栏的子栏目(可传入
  getPermSignColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobmQfsn0tjho0dpmvnot', 'GET', config),
  // 根据刊物Id获取刊期年份
  getJournalMainYears: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0nbjo0zfbst', 'GET', config),
  // 根据刊物Id和年份获取期数
  getJournalMainAnnual: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0nbjo0boovbm', 'GET', config),
  // 根据刊物Id和年份和期数获取下一级节点
  getJournalMainLeaf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0nbjo0mfbg', 'GET', config),
  // 获取封面和折页的接口
  getJournalMainAppend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0nbjo0bqqfoe', 'GET', config),
  // 小样状态过滤列表
  getJournalMainFilterStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0nbjo0gjmufs0tubuvt', 'GET', config),
  // e5/listdata接口
  postJournalE5Listdata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0f60mjtuebub', 'POST', config),
  //获取大样图片（大样详情页用
  getJournalPagesImage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0jnbhft', 'GET', config),
  // 打印期刊小样
  getJournalPrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0qsjou', 'GET', config),

  // 期刊大样PDF查看
  getPdf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0bdujpot0qeg0wjfx', 'GET', config),
  // 期刊大样高精度PDF下载
  getPdfDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0bdujpot0qeg0epxompbe',
      'GET',
      config,
      {
        timeout: 120000
      }
    ),
  // 查看期刊大样流程记录
  getFlowRecords: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0bdujpot0gmpxSfdpset',
      'GET',
      config
    ),
  postJournalLayoutSign: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0mbzpvu0tjho', 'POST', config),
  postJournalLayoutUnsign: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0mbzpvu0votjho', 'POST', config),
  //大样保存大样校对后的信息
  postFullPageProofInfo: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0bdujpot0tbwfGvmmQbhfJogp!',
      'POST',
      config,
      vConfig
    ),

  //大样获取最新的大样校对后的信息
  getFullPageProofInfo: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0bdujpot0hfuGvmmQbhfDifdlJogp',
      'GET',
      config,
      vConfig
    ),
  // 获取审校文档的压缩包 用于UploadProofReviewFile接口参数
  getProofFileZip: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0bdujpot0gjmft0{jq',
      'get',
      config,
      vConfig
    ),
  // 上传审校文档(通过文件路径)
  UploadProofReviewFile: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0gjmf0vqmpbe3', 'post', config, vConfig),
  //添加大样审校流程记录
  addActionsProofRecords: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0qbhft0bdujpot0qsppg0sfdpset',
      'post',
      config,
      vConfig
    ),
  // 开启文件校对任务
  startProofReviewFile: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0w30gjmf', 'post', config, vConfig),

  // 获取任务进度
  getProofReviewProgress: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0qsphsftt', 'get', config, vConfig),

  // 获取任务结果
  getProofReviewResult: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0sftvmu', 'get', config, vConfig),

  // 获取审校生成资源文件url
  getProofReviewResultUrl: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0gjmf0sftvmu0vsm', 'get', config, vConfig)
}
